import { jsxs, jsx } from 'react/jsx-runtime';
import { LoadingState } from '@sketch/components';
import { IndexLayoutHeader } from './IndexLayoutHeader.js';
import { Wrapper } from './IndexLayout.styles.js';
import Sidebar from './Sidebar.js';

const IndexLayoutLoading = ({ headerLink, variant, }) => (jsxs(Wrapper, { children: [jsx(IndexLayoutHeader, { headerLink: headerLink }), variant && jsx(Sidebar, { variant: variant }), jsx(LoadingState, {})] }));

export { IndexLayoutLoading };
